import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import * as LucideIcons from "lucide-react";

export default function Badges() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  useEffect(() => { (async () => { const r = await api.get("/badges/catalog"); setItems(r.data.items || []); })(); }, []);
  const earned = new Set(user?.badges || []);

  return (
    <div className="p-6 md:p-10" data-testid="badges-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Badges</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mt-1">Your trophy case.</h1>
        <p className="text-zinc-600 mt-2 text-sm">Earned {earned.size} of {items.length} badges. Keep going.</p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {items.map((b) => {
          const Icon = LucideIcons[b.icon] || LucideIcons.Award;
          const isEarned = earned.has(b.code);
          return (
            <div key={b.code} className={`card-flat p-6 transition ${isEarned ? '' : 'opacity-60'}`} data-testid={`badge-${b.code}`}>
              <div className={`h-12 w-12 rounded-full flex items-center justify-center ${isEarned ? 'bg-[#0E7C66] text-white' : 'bg-zinc-100 text-zinc-400'}`}>
                <Icon size={20} />
              </div>
              <div className="font-display font-bold text-lg mt-4">{b.name}</div>
              <div className="text-sm text-zinc-600 mt-1">{b.description}</div>
              <div className="mt-4">
                {isEarned ? <span className="tag tag-success">Earned</span> : <span className="tag">Locked</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
